import { memo, useCallback, useRef, useState } from "react";
import PropTypes from "prop-types";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";
import IconSuccessLink from "app/pages/.shared/static/icons/IconSuccessLink";
import "./SmartDPHeroCommercialTag.scss";
import classNames from "classnames";

const IconClipboard = props => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="20"
		height="20"
		viewBox="0 0 20 20"
		fill="none"
		{...props}
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M7.91683 0.91626C9.26825 0.91626 10.3478 0.915366 11.2021 1.01636C12.073 1.1193 12.8071 1.33716 13.4238 1.84318C13.6305 2.01285 13.8206 2.20282 13.9902 2.40959C14.4698 2.99402 14.6905 3.68402 14.8 4.49618C14.8847 5.12475 14.9067 5.87368 14.9131 6.7618C15.3856 6.77396 15.8063 6.79824 16.1769 6.84806C16.9407 6.95079 17.603 7.17313 18.1317 7.70174C18.6603 8.23037 18.8826 8.89267 18.9854 9.65649C19.0852 10.3989 19.0838 11.3426 19.0838 12.4999V13.3333C19.0838 14.4905 19.0852 15.4343 18.9854 16.1767C18.8826 16.9405 18.6603 17.6028 18.1317 18.1314C17.603 18.6601 16.9407 18.8824 16.1769 18.9851C15.4345 19.0849 14.4908 19.0836 13.3335 19.0836H12.5002C11.3429 19.0836 10.3991 19.0849 9.65674 18.9851C8.89292 18.8824 8.23062 18.66 7.70199 18.1314C7.17337 17.6028 6.95104 16.9405 6.84831 16.1767C6.79848 15.8061 6.77421 15.3853 6.76204 14.9128C5.87392 14.9065 5.125 14.8844 4.49642 14.7997C3.68426 14.6903 2.99426 14.4696 2.40983 13.99C2.20307 13.8203 2.0131 13.6303 1.84342 13.4236C1.3374 12.8069 1.11954 12.0727 1.0166 11.2019C0.91561 10.3475 0.916504 9.26801 0.916504 7.91659C0.916504 6.56517 0.91561 5.48565 1.0166 4.63127C1.11954 3.76043 1.33739 3.02629 1.84342 2.40959C2.0131 2.20284 2.20305 2.01287 2.40983 1.84318C3.02654 1.33715 3.76067 1.1193 4.63151 1.01636C5.4859 0.915366 6.56542 0.91626 7.91683 0.91626ZM12.5002 8.25024C11.3005 8.25024 10.4761 8.25163 9.85693 8.33488C9.25935 8.41523 8.96593 8.55858 8.76237 8.76213C8.55883 8.96568 8.41547 9.2591 8.33512 9.85669C8.25188 10.4759 8.25049 11.3002 8.25049 12.4999V13.3333C8.25049 14.533 8.25188 15.3573 8.33512 15.9765C8.41547 16.5741 8.55883 16.8675 8.76237 17.071C8.96593 17.2746 9.25935 17.4179 9.85693 17.4983C10.4761 17.5815 11.3005 17.5829 12.5002 17.5829H13.3335C14.5332 17.5829 15.3575 17.5815 15.9767 17.4983C16.5743 17.4179 16.8677 17.2746 17.0713 17.071C17.2748 16.8675 17.4182 16.5741 17.4985 15.9765C17.5818 15.3573 17.5832 14.533 17.5832 13.3333V12.4999C17.5832 11.3002 17.5818 10.4759 17.4985 9.85669C17.4182 9.25911 17.2748 8.96568 17.0713 8.76213C16.8677 8.55858 16.5743 8.41523 15.9767 8.33488C15.3575 8.25163 14.5332 8.25024 13.3335 8.25024H12.5002ZM7.91683 2.41691C6.52868 2.41691 5.55318 2.41745 4.80729 2.50562C4.07813 2.59183 3.66633 2.7524 3.36117 3.00285C3.23039 3.11016 3.11044 3.23012 3.00309 3.36092C2.75265 3.66609 2.59208 4.07789 2.50586 4.80705C2.41769 5.55293 2.41716 6.52843 2.41716 7.91659C2.41716 9.30475 2.41769 10.2802 2.50586 11.0261C2.59208 11.7553 2.75263 12.1671 3.00309 12.4722C3.11042 12.603 3.23038 12.723 3.36117 12.8303C3.65066 13.0679 4.03617 13.2239 4.69662 13.3129C5.22886 13.3846 5.88777 13.4055 6.74984 13.4122V12.4999C6.74984 11.3426 6.7485 10.3989 6.84831 9.65649C6.95104 8.89268 7.17338 8.23037 7.70199 7.70174C8.23062 7.17313 8.89292 6.95079 9.65674 6.84806C10.3991 6.74825 11.3429 6.74959 12.5002 6.74959H13.4124C13.4057 5.88753 13.3849 5.22862 13.3132 4.69637C13.2241 4.03592 13.0682 3.65041 12.8306 3.36092C12.7233 3.23015 12.6033 3.1102 12.4725 3.00285C12.1673 2.75239 11.7555 2.59183 11.0264 2.50562C10.2805 2.41745 9.30499 2.41691 7.91683 2.41691Z"
			fill="white"
		/>
	</svg>
);

const SmartDPHeroCommercialTag = ({ tag, enableCopy = false }) => {
	const [copied, setCopied] = useState(false);
	const textRef = useRef(null);

	const copyText = useCallback(event => {
		if (event?.stopPropagation) {
			event.stopPropagation();
		}

		if (!tag) {
			return;
		}

		if (!navigator?.clipboard?.writeText) {
			return;
		}

		navigator.clipboard
			.writeText(tag)
			.then(() => {
				setCopied(true);
				setTimeout(() => {
					setCopied(false);
				}, 2000);
			})
			.catch(() => {});
	}, []);

	const handleKeyDown = useCallback(
		event => {
			if (event.key === "Enter" || event.key === " ") {
				event.preventDefault();
				copyText(event);
			}
		},
		[copyText]
	);

	if (!tag) {
		return null;
	}

	const icon = copied ? (
		<IconSuccessLink width={20} height={20} />
	) : (
		<IconClipboard width={20} height={20} />
	);

	return (
		<Typography
			variant={TYPOGRAPHY_VARIANTS.REGULAR}
			variantMD={TYPOGRAPHY_VARIANTS.XL}
			variantLG={TYPOGRAPHY_VARIANTS.XL3}
			isBold
			className={classNames("smartDP-hero-commercial__tag", {
				"smartDP-hero-commercial__tag--copyable": enableCopy,
			})}
			data-testid="smartDP-hero-commercial-tag"
			component="div"
			tabIndex={0}
			{...enableCopy && {
				ariaLabel: "Copy to clipboard",
				role: "button",
				onClick: copyText,
				onKeyDown: handleKeyDown,
			}}
		>
			<span ref={textRef}>{tag}</span>
			{enableCopy && <span className="smartDP-hero-commercial__tag-icon">{icon}</span>}
		</Typography>
	);
};

SmartDPHeroCommercialTag.propTypes = {
	tag: PropTypes.node,
	enableCopy: PropTypes.bool,
};

export default memo(SmartDPHeroCommercialTag);
